import Axios from "axios";

class FuncionarioGedDataService {
  consultarEndereco(id) {
    return Axios.get(`funcionarioGed/${id}/endereco`).then(
      (response) => response.data.url
    );
  }
  meusDocumentos(funcionarioId) {
    return Axios.get(`funcionarioGed/meus-documentos/${funcionarioId}`).then(
      (response) => response.data
    );
  }

  baixar(id, portal = false, numero = null) {
    const endpoint = portal
      ? `funcionarioGed/meus-documentos/arquivo/${id}`
      : numero == null
      ? `funcionarioGed/${id}/arquivo`
      : `funcionarioGed/${id}/versoes/${numero}/arquivo`;
    return Axios.get(endpoint, { responseType: "blob" });
  }

  versoes(id) {
    return Axios.get(`funcionarioGed/${id}/versoes`).then(
      (response) => response.data
    );
  }

  acessos(id, page = 0, linesPerPage = 30) {
    return Axios.get(`funcionarioGed/${id}/acessos`, {
      params: { page, linesPerPage },
    }).then((response) => response.data);
  }

  substituir(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return Axios.put(`funcionarioGed/${id}/arquivo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  salvarDownload(response, nomeArquivo) {
    const url = URL.createObjectURL(response.data);
    const disposition = response.headers?.["content-disposition"] || "";
    const nomeCabecalho = /filename="([^"]+)"/.exec(disposition)?.[1];
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo || nomeCabecalho || "documento.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
}

export default new FuncionarioGedDataService();
